module.exports = __webpack_public_path__ + "static/media/feather.bd1a3148.svg";